import type { LucideIcon } from 'lucide-react';
import {
  DollarSign,
  GitBranch,
  GitPullRequest,
  Github,
  Cloud,
  Cpu,
  Ticket,
  GitMerge,
  Plug,
  Database,
  BarChart2,
  Rocket,
  UtensilsCrossed,
  Users,
  Sparkles,
  ShieldCheck,
  Shapes,
} from 'lucide-react';

const ICON_MAP: Record<string, LucideIcon> = {
  'dollar-sign': DollarSign,
  'git-branch': GitBranch,
  'git-pull-request': GitPullRequest,
  github: Github,
  'github-graphql': Github,
  cloud: Cloud,
  cpu: Cpu,
  ticket: Ticket,
  jira: Ticket,
  linear: Ticket,
  'git-merge': GitMerge,
  gitlab: GitMerge,
  plug: Plug,
  database: Database,
  'bar-chart-2': BarChart2,
  rocket: Rocket,
  'utensils-crossed': UtensilsCrossed,
  internal: Users,
  multi: Sparkles,
  solidafy: ShieldCheck,
  other: Shapes,
};

export function resolveIcon(name: string, fallback: LucideIcon = Plug): LucideIcon {
  return ICON_MAP[name] || fallback;
}
